import React, { useEffect, useState } from "react";
// import { fetchToken } from "../../../../features/common/FetchCookie";
import HomeLoggedIn from "./HomeLoggedIn";
import { Home } from "./Home";
import { fetchToken } from "../../../features/common/FetchCookie";

const HomePage = () => {
  const [isLogin, setIsLogin] = useState(null); // null = loading

  useEffect(() => {
    const fetchingToken = async () => {
      const token = await fetchToken();
      setIsLogin(!!token);
    };
    fetchingToken();
  }, []);

  // Don't render anything until auth state is determined
  if (isLogin === null) {
    return null;
  }

  return <div>{isLogin ? <HomeLoggedIn /> : <Home />}</div>;
};

export default HomePage;
